import { render } from "./IpraModalCard.vue?vue&type=template&id=217aa722&scoped=true"
import script from "./IpraModalCard.vue?vue&type=script&lang=js"
export * from "./IpraModalCard.vue?vue&type=script&lang=js"

import "./IpraModalCard.vue?vue&type=style&index=0&id=217aa722&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217aa722"]])

export default __exports__